import React from 'react';

const UnavailableIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.7695 9.39746C17.7695 14.0919 13.964 17.8975 9.26953 17.8975C4.57511 17.8975 0.769531 14.0919 0.769531 9.39746C0.769531 4.70304 4.57511 0.897461 9.26953 0.897461C13.964 0.897461 17.7695 4.70304 17.7695 9.39746Z"
        fill="#FF0000"
      />
      <path
        d="M12.7704 5.51367L5.38501 12.8991"
        stroke="white"
        strokeWidth="1.84635"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.38537 5.51367L12.7708 12.8991"
        stroke="white"
        strokeWidth="1.84635"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnavailableIcon;
